require(
  [
    'a11ydialog',
    'results',
    'touchHelper',
    'history',
    'favoritesHandler',
    'resultsSortBy',
    'pageSizeHandler',
    'labelMoreSection',
    'guidGenerator',
    'prefillForm',
  ],
  (A11yDialog) => {
    'use strict';

    const facetSection = document.querySelectorAll('#nhs_ResFacets, [data-reset-filters]');
    const mapSection = document.querySelector('[data-static-map]');
    const locationSelect = document.querySelector('#marketId');
    const containerCardResults = document.querySelector('[data-card-container]');

    window.A11yDialog = A11yDialog;

    /**
     * @private
     * initFacets: load modules to facets.
     *
     * @param {Event} event with the information associated to the click event.
     */
    function initFacets(event) {
      for (let index = 0; index < facetSection.length; index += 1) {
        const element = facetSection[index];
        element.removeEventListener('click', initFacets);
      }
      require(['filterAmenityComponent'], (filterAmenityComponent) => {
        filterAmenityComponent.init();
        const forLabel = event.target.closest('[for]');
        if (forLabel && document.querySelector('#' + forLabel.getAttribute('for')).type === 'checkbox') {
          document.querySelector('#' + forLabel.getAttribute('for')).dispatchEvent(new Event('change'));
        } else {
          event.target.click();
        }
      });
    }

    /**
     * @private
     * openFreeBrocure: open brochure modal.
     *
     * @param {Event} event with the information associated to the click or touch event.
     */
    function openFreeBrocure(event) {
      const target = event.target;

      if (!target.dataset.loadModal) {
        return;
      }

      // this should be there here to avoid two calls to the window modal functionality
      event.stopPropagation();

      require(
        ['freeBrochure'],
        (freeBrochure) => {
          freeBrochure.openModal(target);
        }
      );
    }

    /**
     * @private
     * loadAds: load ads and skeleton to page.
     *
     */
    function loadAds() {
      require(['onLoadedUtils'], () => { });
    }

    /**
     * @private
     * onDomComplete: handler event when dom complete is trigger.
     *
     */
    function onDomComplete() {
      if (typeof window.requestIdleCallback === 'function') {
        window.requestIdleCallback(loadAds, { timeout: 1000 });
      } else {
        setTimeout(loadAds, 1000);
      }
    }

    /**
     * @private
     * initMap: init the map when is clicked or market is change.
     *
     */
    function initMap() {
      this.removeEventListener('click', initMap);
      locationSelect.removeEventListener('change', initMap);
      require(['mapAmenityResults'], (mapAmenityResults) => {
        mapSection.setAttribute('hidden', '');
        mapAmenityResults.init();
      });
    }

    for (let index = 0; index < facetSection.length; index += 1) {
      const element = facetSection[index];
      element.addEventListener('click', initFacets);
    }

    if (document.readyState === 'complete') {
      onDomComplete();
    } else {
      window.addEventListener('load', onDomComplete);
    }

    mapSection.addEventListener('click', initMap);
    locationSelect.addEventListener('change', initMap);
    containerCardResults.addEventListener('click', openFreeBrocure);
  }
);

define("nhs/views/AmenityResults/Show", function(){});

